import { render } from "./cwtj.vue?vue&type=template&id=2ead7acd&scoped=true"
import script from "./cwtj.vue?vue&type=script&lang=js"
export * from "./cwtj.vue?vue&type=script&lang=js"

import "./cwtj.vue?vue&type=style&index=0&id=2ead7acd&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ead7acd"]])

export default __exports__